/* section-footer.js — extracted from sections/footer.liquid */
function toggleFooterAccordion(btn) {
    const parent = btn.closest('.footer-col-item');
    if (!parent) return;
    const open = parent.classList.toggle('is-open');
    // The button carried a hardcoded aria-expanded="false", so assistive tech
    // was told the column was collapsed even while it was open.
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    parent.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
